var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58125 6.85956C6.45112 6.73071 6.27539 6.65843 6.09225 6.65843C5.90912 6.65843 5.73339 6.73071 5.60325 6.85956C5.539 6.92283 5.48798 6.99825 5.45315 7.08143C5.41833 7.16461 5.40039 7.25388 5.40039 7.34406C5.40039 7.43423 5.41833 7.52351 5.45315 7.60669C5.48798 7.68987 5.539 7.76529 5.60325 7.82856L9.51125 11.6586C9.64168 11.7872 9.81754 11.8594 10.0008 11.8594C10.184 11.8594 10.3598 11.7872 10.4903 11.6586L14.3983 7.82856C14.4625 7.76529 14.5135 7.68987 14.5484 7.60669C14.5832 7.52351 14.6011 7.43423 14.6011 7.34406C14.6011 7.25388 14.5832 7.16461 14.5484 7.08143C14.5135 6.99825 14.4625 6.92283 14.3983 6.85956C14.2678 6.73089 14.092 6.65874 13.9088 6.65874C13.7255 6.65874 13.5497 6.73089 13.4193 6.85956L9.99925 10.0006L6.58125 6.85956Z",
    fill: "#FF9777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrow);
export default __webpack_public_path__ + "static/media/downloadArrow.3566622f4c0a52810322d28970e3fee7.svg";
export { ForwardRef as ReactComponent };